import { render, staticRenderFns } from "./ManageLanguages.vue?vue&type=template&id=34f0d2de"
import script from "./ManageLanguages.vue?vue&type=script&lang=js"
export * from "./ManageLanguages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports